import { useSelector } from "react-redux";
import { selectVersion } from "./counterSlice";
import useIndexedDB from "../../hooks/useIndexedDB";

const handleVersionChange = (e, deleteDB) => {
  sessionStorage.setItem("ccms_selected_version", e.currentTarget.value);
  deleteDB(e.currentTarget.value);
  document.location.reload();
};

const Version = (props) => {
  let ccmsversion = useSelector(selectVersion);

  const { deleteDB } = useIndexedDB();
  return (
    <select
      className="ccmsversion"
      value={ccmsversion.selected}
      onChange={(e) => handleVersionChange(e, deleteDB)}
    >
      {ccmsversion.items.map(({ label, value }) => {
        return (
          <option key={value} value={value}>
            {label}
          </option>
        );
      })}
    </select>
  );
};

export default Version;
